import React, { type FC } from 'react';
import { Helmet, HelmetProvider, type HtmlProps } from 'react-helmet-async';
import { useIsRTLLayout } from '../appState/hooks/useIsRTLLayout';
import { useLanguageContext } from '../lib/hooks/useLanguageContext';

const iconPath = `/favicon.ico`;

export const WrapHelmet: FC<React.PropsWithChildren> = ({ children }) => {
  const isRTLLayout = useIsRTLLayout();
  const [language] = useLanguageContext();
  const htmlAttrs = {
    dir: isRTLLayout ? 'rtl' : 'ltr',
    lang: language,
    className: 'notranslate',
    translate: 'no',
  } as HtmlProps;
  return (
    <HelmetProvider>
      <Helmet htmlAttributes={htmlAttrs}>
        <title>CyberQ Portal</title>
        <link rel="icon" href={iconPath} />
        <link rel="apple-touch-icon" href={iconPath} />
        <meta name="version" content={import.meta.env.REACT_APP_BUILD_NUMBER ?? 'not available'} />
        <meta name="theme-color" content="#000000" />
        <meta name="google" content="notranslate" />
      </Helmet>
      {children}
    </HelmetProvider>
  );
};
